import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from "react";

interface DocumentReviewContextType {
  documentsToReview: string[];
  setDocumentsToReview: (documentIds: string[]) => void;
  clearDocumentsToReview: () => void;
}

const DocumentReviewContext = createContext<DocumentReviewContextType | undefined>(undefined);

interface DocumentReviewProviderProps {
  children: ReactNode;
}

export function DocumentReviewProvider({ children }: DocumentReviewProviderProps) {
  const [documentsToReview, setDocumentsToReview] = useState<string[]>([]);

  const clearDocumentsToReview = useCallback(() => {
    setDocumentsToReview([]);
  }, []);

  const contextValue = useMemo(
    () => ({
      documentsToReview,
      setDocumentsToReview,
      clearDocumentsToReview,
    }),
    [documentsToReview, clearDocumentsToReview]
  );

  return (
    <DocumentReviewContext.Provider value={contextValue}>{children}</DocumentReviewContext.Provider>
  );
}

export function useDocumentReview(): DocumentReviewContextType {
  const context = useContext(DocumentReviewContext);
  if (context === undefined) {
    throw new Error("useDocumentReview must be used within a DocumentReviewProvider");
  }
  return context;
}
